import { Link, useNavigate } from "react-router-dom";
import Logo from "../../components/Logo";
import { FormEvent, useMemo, useState } from "react";
import { resetPassword } from "../../api/authProfessional";
import { RequiredMark } from "../../components/RequiredMark";

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const PENDING_RESET_EMAIL_KEY = "agbaza.pro.reset.email";

export default function ProForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const emailValid = useMemo(() => emailRegex.test(email.trim()), [email]);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!emailValid) return;
    setError("");
    setSubmitting(true);
    const result = await resetPassword(email.trim());
    setSubmitting(false);
    if (!result.ok) {
      setError(result.message || "Impossible d'envoyer le code.");
      return;
    }
    sessionStorage.setItem(PENDING_RESET_EMAIL_KEY, email.trim());
    navigate("/professionnel/mot-de-passe/code", {
      state: { email: email.trim(), mode: "reset" },
    });
  };

  return (
    <div className="relative h-screen overflow-hidden">
      <img
        src={import.meta.env.BASE_URL + 'maps-reset-side.jpg'}
        alt="pro-forgot-bg"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/30" />

      <div className="absolute inset-0 z-10 px-4 md:px-8 py-6 md:py-8 flex">
        <div className="max-w-6xl mx-auto flex flex-col w-full">

          <div className="mt-auto flex items-end justify-between gap-6 pl-2 md:pl-6 pr-4 md:pr-8 pb-4 md:pb-8">
            <div className="w-full max-w-2xl min-h-[520px] bg-white/95 backdrop-blur rounded-[12px] shadow p-8 md:p-10">
              <h1 className="text-2xl font-semibold" style={{ color: '#0B1F16' }}>Recuperation du mot passe</h1>
              <p className="mt-2 text-sm text-gray-600">Entrez votre email et nous vous enverrons un code de verification.</p>
              {error && (
                <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-[10px] px-3 py-2">
                  {error}
                </div>
              )}
              <form className="mt-6 space-y-4" onSubmit={onSubmit}>
                <div className="space-y-2">
                  <label className="text-sm" style={{ color: '#0B1F16' }}>
                    Email
                    <RequiredMark />
                  </label>
                  <input
                    type="email"
                    placeholder="exemple@domaine.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value.replace(/\s/g, ""))}
                    className={`w-full h-11 rounded-[10px] border-2 px-3 ${emailValid || email === '' ? '' : 'border-red-400'}`}
                    style={{ borderColor: emailValid || email === '' ? '#D1E2DD' : '#F87171' }}
                  />
                </div>
                <button
                  type="submit"
                  disabled={!emailValid || submitting}
                  className="w-full h-11 rounded-[10px] font-medium cursor-pointer disabled:opacity-60"
                  style={{ backgroundColor: '#00553E', color: '#FFFFFF' }}
                >
                  {submitting ? "Envoi..." : "Envoyer le code"}
                </button>
                <Link to="/professionnel/connexion" className="block">
                  <button type="button" className="w-full h-11 rounded-[10px] font-medium border-2 cursor-pointer" style={{ borderColor: '#D1E2DD', color: '#00553E' }}>
                    Retour
                  </button>
                </Link>
              </form>
            </div>
            <div className="hidden md:block shrink-0">
              <img src={import.meta.env.BASE_URL + 'Group 5.png'} alt="agabaza-logo" className="w-auto" style={{ height: 144 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

